import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MulticurrencyComponent } from '@app/shared/components/donate/multi-currency/multi-currency.component';
import { CurrencySymbolModule } from '@app/shared';
import { GivebriteConfig, GivebriteState } from '@app/state';
import { ButtonComponent, IconComponent } from '@app/ui';
import { PLATFORM_LOGO_SRC } from '@app/core/site-context';
import { LayoutContext } from '../../../../layout-context.model';
import { AppRoutes } from '@app/core/routing';
import { HeaderAccountMenuComponent } from '../../shared/header-account-menu/header-account-menu.component';
import { HeaderNavActionsComponent } from '../../shared/header-nav-actions/header-nav-actions.component';
import { Store } from '@ngxs/store';
import { filter, Observable } from 'rxjs';

@Component({
  selector: 'gb-header-modern',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    IconComponent,
    MulticurrencyComponent,
    CurrencySymbolModule,
    HeaderAccountMenuComponent,
    HeaderNavActionsComponent,
  ],
  templateUrl: './header-modern.component.html',
  styleUrls: ['./header-modern.component.scss'],
})
export class HeaderModernComponent {
  protected readonly AppRoutes = AppRoutes;

  @Input({ required: true }) ctx!: LayoutContext;

  private readonly store = inject(Store);

  config$: Observable<GivebriteConfig> = this.store.select(GivebriteState.config);

  @ViewChild(MulticurrencyComponent) private multicurrencyComponent?: MulticurrencyComponent;

  readonly platformLogoSrc = PLATFORM_LOGO_SRC;

  isBrowser = false;
  menuOpen = false;
  isOpenCurrencySelector = false;
  donatePage = false;
  dashboardUrl = '/dashboard';

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.updateDonatePage(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event) => {
        this.updateDonatePage(event.urlAfterRedirects);
      });
  }

  /** Platform / invalid-host shells use Givebrite chrome branding. */
  get isPlatformApp(): boolean {
    return this.ctx.app !== 'charity';
  }

  openCurrencySelector(): void {
    this.multicurrencyComponent?.toggleCurrency();
  }

  currencySelector(isOpen: boolean): void {
    this.isOpenCurrencySelector = isOpen;
  }

  toggleMobileDrawer(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMobileDrawer(): void {
    this.menuOpen = false;
  }

  /** DaisyUI's overlay label flips the checkbox directly, so mirror it back. */
  onDrawerToggle(event: Event): void {
    this.menuOpen = (event.target as HTMLInputElement).checked;
  }

  private updateDonatePage(url: string): void {
    this.donatePage = url.split('?')[0].split('/').includes('donate');
  }
}
